import type { EditorSDK } from '@wix/platform-editor-sdk';

import { APP_TOKEN } from '../constants';

export const isApplicationInstalled = (editorSDK: EditorSDK, appDefinitionId: string) =>
  editorSDK.application.isApplicationInstalled(APP_TOKEN, { appDefinitionId });
